<template>
  <div class="box7">
    <div class="top-scorll-box">
      <div class="content" @scroll="handleScroll">
        <div class="block" ref="content">
          <div
            class="item"
            v-for="(item, index) in teacherList.slice(0, 3)"
            :key="index"
          >
            <img
              :src="
                require(`../../../assets/coursePage/pythonData/box7/${
                  index + 1
                }.png`)
              "
              alt
            />
            <div class="text">
              <div class="name">{{ item.name }}</div>

              <p class="info">{{ item.tag }}</p>
            </div>
          </div>
          <div class="box"></div>
        </div>

        <div class="block">
          <div
            class="item"
            v-for="(item, index) in teacherList.slice(3, 6)"
            :key="index"
          >
            <img
              :src="
                require(`../../../assets/coursePage/pythonData/box7/${
                  index + 4
                }.png`)
              "
              alt
            />
            <div class="text">
              <div class="name">{{ item.name }}</div>
              <p class="info">{{ item.tag }}</p>
            </div>
          </div>
          <div class="box"></div>
        </div>
      </div>
    </div>

    <!-- <div class="scorll-box">
      <div class="scorll-block" :style="styleVar"></div>
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      teacherList: [
        {
          name: "赵老师",
          tag: "985计算机硕士 | 擅长大数据 | 人工智能技术方向",
        },
        {
          name: "李老师",
          tag: "985计算机硕士 | Apache Doris社区贡献者",
        },
        {
          name: "曹老师",
          tag: "Apache Flink源码贡献者 | 擅长大数据云平台技术领域",
        },
        {
          name: "赵老师",
          tag: "Apache Pulsar社区贡献者 | 擅长数仓领域",
        },
        // {
        //   name: "史老师",
        //   tag: "大数据架构师 | 拥有丰富的技术攻坚经验",
        // },
        // {
        //   name: "原老师",
        //   tag: "北京大学计算机硕士 | 擅长大数据 | 人工智能领域技术",
        // },
        {
          name: "孔老师",
          tag: "Apache DolphinScheduler社区贡献者 | 擅长离线数仓领域",
        },
        {
          name: "张老师",
          tag: "Apache Flink源码贡献者 | 擅长实时计算领域",
        },

      ],
      scroll: 0,
    };
  },
  computed: {
    styleVar() {
      return {
        "--box-left": this.scroll + "px",
      };
    },
  },
  methods: {
    handleScroll() {
      let dom = this.$refs.content.getBoundingClientRect();
      let left = Math.abs(parseInt(dom.x)) / 25;
      if (left >= 1) {
        this.scroll = left;
      } else {
        this.scroll = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.box7 {
  position: relative;
  padding-bottom: 58px;
  width: 100%;
  background: linear-gradient(180deg, #cef0ff 0%, #f3fbff 100%);
  // overflow: hidden;
  .box {
    width: 2px;
    flex-shrink: 0;
  }
  .scorll-box {
    position: absolute;
    left: 50%;
    bottom: 80px;
    transform: translate(-50%, 0px);
    width: 60px;
    height: 6px;
    background: rgba(46, 165, 252, 0.16);
    border-radius: 3px;
    .scorll-block {
      position: absolute;
      left: var(--box-left);
      width: 20px;
      height: 6px;
      background: #2ea5fc;
      border-radius: 3px;
    }
  }

  .top-scorll-box {
    width: 100%;
    overflow: hidden;
  }
  .content {
    position: relative;
    padding: 0px 30px;
    overflow-x: auto;
    &::-webkit-scrollbar {
      display: none;
      width: 0 !important;
      height: 0 !important;
      color: transparent;
    }
    .block {
      display: flex;
      padding-right: 20px;
    }
  }
  .item {
    position: relative;
    margin-right: 30px;
    margin-bottom: 30px;

    // background-color: #e0f5ff;
    border-radius: 10px;

    img {
      width: 314px;
      height: 394px;
    }

    .text {
      position: absolute;
      top: 256px;
      padding-left: 24px;
      padding-right: 18px;
      font-family: PingFang SC;
      font-size: 20px;
      font-weight: normal;
      font-stretch: normal;
      line-height: 30px;
      letter-spacing: 1px;
      color: #ffffff;
      box-sizing: border-box;
      .name {
        margin-bottom: 4px;
        font-size: 28px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
        line-height: 40px;
      }
      .info {
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 28px;
        word-wrap: break-word;
        word-break: break-all;
      }
    }
  }
}
</style>
